import { render, staticRenderFns } from "./editEsportsTournament.vue?vue&type=template&id=51831e00&"
import script from "./editEsportsTournament.vue?vue&type=script&lang=js&"
export * from "./editEsportsTournament.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports